import { PartyPopper } from 'lucide-react';
import './GreatJobBadge.css';

// Positive empty state ("nothing is failing"), used where a "great job" image used to be.
const GreatJobBadge = ({ message }) => (
  <div className="great-job-badge" role="status">
    <span className="great-job-badge-icon">
      <PartyPopper size={20} strokeWidth={2} aria-hidden="true" />
    </span>
    <div className="great-job-badge-text">
      <span className="great-job-badge-title">Great job!</span>
      {message && <span className="great-job-badge-message">{message}</span>}
    </div>
  </div>
);

export default GreatJobBadge;
